import {MNullable} from '../../Toolkit/Utils';

export class Report {
    public name: string = '';
    public embedUrl: string = '';
    public reportId: string = '';
};

export class Group {
    public name: string = '';
    public groupId: string = '';
}

export class ReportReply {
    public report: MNullable<Report> = null;
};

export class ReportMultiReply {
    public embedToken: string = '';
    public reports: Report[] = [];
};

export class GroupReply {
    public group: MNullable<Group> = null;
}

export class GroupMultiReply {
    public groups: Group[] = [];
}